module.exports = "https://coursera_assets.s3.amazonaws.com/images/950b726c1d24b787a34c163b29f8f6ff.png";